<div class="nav" [class.open]="navigationOpen" [class.nav-transition]="!windowResizing">
  <a routerLink="/dashboard">
    <div class="nav-header">
      <div class="nav-close mr-8" (click)="closeNavigation()"><i class="fa-light fa-xmark"></i></div>
      <img [src]="'logo_large' | providerImage" [alt]="'logo_large' | providerImage: 'altText'" />
    </div>
  </a>
  <nav class="nav-body">
    <div class="nav-items">
      <a class="nav-item" routerLinkActive="active" [routerLink]="['/dashboard']">
        <div class="nav-icon">
          <i class="nav-icon fa-kit fa-dashboard"></i>
        </div>
        <div class="nav-item-label" [innerText]="'Sidebar.Overview' | translate"></div>
      </a>
      <a class="nav-item" routerLinkActive="active" [routerLink]="['/products']">
        <div class="nav-icon">
          <i class="fa-kit fa-contract"></i>
        </div>
        <div class="nav-item-label" [innerText]="'Sidebar.LocationsTariffs' | translate"></div>
      </a>
      <a class="nav-item" routerLinkActive="active" [routerLink]="['/vehicles']">
        <div class="nav-icon">
          <i class="fa-kit fa-vehicles"></i>
        </div>
        <div class="nav-item-label" [innerText]="'Sidebar.VehiclesAndContracts' | translate"></div>
      </a>
      @if (enableBilling) {
        <a class="nav-item" routerLinkActive="active" [routerLink]="['/billing']">
          <div class="nav-icon">
            <i class="fa-kit fa-wallet"></i>
          </div>
          <div class="nav-item-label" [innerText]="'Sidebar.Billing' | translate"></div>
        </a>
        <a class="nav-item" routerLinkActive="active" [routerLink]="['/data']">
          <div class="nav-icon">
            <i class="fa-kit fa-data"></i>
          </div>
          <div class="nav-item-label" [innerText]="'Sidebar.ProfileSettings' | translate"></div>
        </a>
      }
      @if (enableVoucher) {
        <a class="nav-item" routerLinkActive="active" [routerLink]="['/voucher']">
          <div class="nav-icon">
            <i class="fa-light fa-gift-card"></i>
          </div>
          <div class="nav-item-label" [innerText]="'Sidebar.Voucher' | translate"></div>
        </a>
      }
      <a class="nav-item" routerLinkActive="active" [routerLink]="['/help']">
        <div class="nav-icon">
          <i class="fa-kit fa-info"></i>
        </div>
        <div class="nav-item-label" [innerText]="'Sidebar.HelpContact' | translate"></div>
      </a>
      @if (showAccessCardTab) {
        <a class="nav-item" routerLinkActive="active" [routerLink]="['/access-card']">
          <div class="nav-icon">
            <i class="fa-light fa-door-open"></i>
          </div>
          <span class="nav-item-label" [innerText]="'Sidebar.DoorOpener' | translate"></span>
        </a>
      }
      <a class="nav-item cursor-pointer" (click)="onLogOutClicked()">
        <div class="nav-icon">
          <i class="fa-kit fa-logout"></i>
        </div>
        <div class="nav-item-label" [innerText]="'Sidebar.LogOut' | translate"></div>
      </a>
    </div>
  </nav>
  <div class="nav-footer">
    <div class="nav-footer-languages">
      <a (click)="changeLanguage('de')" [class.active]="getCurrentLanguage() === 'de'">Deutsch</a> |
      <a (click)="changeLanguage('en')" [class.active]="getCurrentLanguage() === 'en'">English</a>
    </div>
    <arivo-legal-links></arivo-legal-links>
    <div class="nav-footer-branding my-3 inline items-center">
      <div class="body-small mr-1 text-neutral-70">Powered by</div>
      <img [src]="'/assets/brands/arivo.svg' | url" alt="Arivo" />
    </div>
  </div>
</div>
<div class="nav-backdrop" (click)="closeNavigation()"></div>
